import { type SupportedLocale } from '@zep-us/i18n';

export const INQUIRY_LINK: Partial<Record<SupportedLocale, string>> = {
  ko: 'https://tally.so/r/Ekd7oN',
  en: 'https://tally.so/r/rjaMZM',
  ja: 'https://tally.so/r/44JVbb',
};

export const handleContactSalesClick = (locale: SupportedLocale) => {
  const inquiryUrl = INQUIRY_LINK[locale] ?? INQUIRY_LINK.en;
  window.open(inquiryUrl, '_blank', 'noopener,noreferrer');
};
